<template>
	<div class="group2b_M">
		<!-- group2b_M -->

		<el-skeleton :rows="20" :loading="loadingMask" animated>
			<template>
				
				<div class="item_title">
					<h1>{{colname}}</h1>
				</div>
				
				<div class="thematic_list  ">
					<!-- thematic_list -->
					<section v-for="(item,index) in moreDataList">
						<dl>
							<!-- <dt>
								<div class="T-date">
									<d1>{{item.updateTime.substring(8,10)}}</d1>
									<d2>{{item.updateTime.substring(0,7).replace('-','/')}}</d2>
								</div>
							</dt> -->
							<dd>
								<a @click="jumppush('/detail/'+item.id+'?col='+sourcecol)" class="T-tit"
													v-html="item.articletype+item.title" ></a>
							</dd>
							<R style="color: #a1a4ab;">{{item.publishtime.substring(0,10)}}</R>
						</dl>
						<dl>
							<!-- <dt>
								<T-vline></T-vline>
							</dt> -->
							<dd>
								<div class="list_txt">
									<!--  -->
									<p>
										{{item.summary}}
									</p>
								</div><!-- / -->
							</dd>
						</dl>
					</section>
					
				</div><!-- /thematic_list -->
				
				<div class="m_b1"></div>
				
				<ul class="pages">
					<!-- /pages -->
					<el-pagination @size-change="changePageSize" @current-change="changeSearchPage"
						:current-page="pageNum" :page-sizes="[10, 20, 30]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="moreTotalCount">
					</el-pagination>
				</ul><!-- /pages -->
				
				
			</template>
		</el-skeleton>


		


	</div><!-- /group2b_M -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 10,
				moreTotalCount: 0,
				moreDataList:[]
			}
		},
		props:[
			'colid',
			'colname',
			'sourcecol',
		],
		watch: {
			colid:function(){
				this.pageNum = 1;
				this.getlistfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			}
		},
		mounted: function() {
			this.pageNum = 1;
			this.getlistfnc();
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			jumppush:function(to){
				var a = document.createElement('a');
				a.setAttribute('href', to);
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a); 
			},
			getlistfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'subject/getHotSubjectArticles',
						responseType: 'json',
						params: {
							columnID: this.colid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.moreDataList = response.data.data.data.data;
						_this.moreTotalCount=response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getlistfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.getlistfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
		}
	}
</script>

<style>
</style>
